import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { numericFormatter } from 'react-number-format';

import { Grid, Card, List, Typography } from '@material-ui/core';
import Loader from 'components/Loader';
import Button from 'components/Button';
import Item from '../../components/SellOrder/components/Item';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';
import { formatDocument, formatPhone } from 'helpers/formatters';
import { convertToBrl } from 'helpers/converters';

import { useStyles } from '../../components/SellOrder/components/styles';

export default function SellOrderConsult() {
  const { width } = useWindowDimensions();
  const isMobile = width < 1024;

  const classes = useStyles();

  const { orderId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [order, setOrder] = useState({});

  useEffect(() => {
    (async () => {
      if(orderId) {
        setIsLoading(true);

        try {
          const { data } = await Axios.get(`${process.env.REACT_APP_NEW_BASE_API}/order`, {
            params: {
              orderId: decodeURIComponent(orderId)
            }
          });

          setOrder(data?.data);
        } catch(error) {
          if(!!error.response?.data?.data?.msg) {
            toast.error(error.response?.data?.data?.msg);
          }

          setOrder({});
        } finally {
          setIsLoading(false);
        }
      }
    })();
  }, [orderId]);

  useEffect(() => {
    if(!!order?.nfceLink) {
      window.location.replace(order?.nfceLink);
    }
  }, [order?.nfceLink]);

  const consultNfce = async () => {
    try {
      const { data } = await Axios.get(`${process.env.REACT_APP_NEW_BASE_API}/order/consult`, {
        params: {
          orderId: decodeURIComponent(orderId)
        }
      });

      if(!!data?.data?.nfceLink) {
        window.location.replace(data?.data?.nfceLink);
      }

      if(!data?.data?.nfceLink) {
        toast.error('Link da nota fiscal não disponível.');
      }
    } catch(_) {
      toast.error('Houve um erro ao visualizar a nota fiscal.');
    }
  }

  return(
    <Loader isLoading={isLoading} style={{ height: '100vh', width: '100vw' }}>
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={isMobile ? 12 : 6}>
          <Card elevation={0} className={classes.card}>
            <List disablePadding className={classes.list}>
              <Item primary="N° Pedido:">{order?.orderCode}</Item>
              <Item primary="Registro do Pedido:">{order?.userName}</Item>
              {!!order?.registrationDateTime && (
                <Item primary="Registro:">{moment(order?.registrationDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}</Item>
              )}
              <Item primary="Venda do Pedido:">{order?.transactionUserName}</Item>
              {!!order?.paymentDateTime && (
                <Item primary="Venda:">{moment(order?.paymentDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}</Item>
              )}
              <Item primary="Meio de Pagamento:">{order?.paymentMethodName}</Item>
              {(!!order?.discountAmount && +order?.discountAmount > 0) && (
                <Item primary="Desconto:">
                  {+order?.discount?.type?.typeId == 1 ? `${numericFormatter(order?.discountAmount?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })} %` : convertToBrl(parseFloat(order?.discountAmount))}
                </Item>
              )}
              {!!order?.productsAmount && (
                <Item primary="Valor:">
                  {`R$ ${numericFormatter(order?.productsAmount?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}`}
                </Item>
              )}
            </List>
          </Card>
        </Grid>
        <Grid item xs={isMobile ? 12 : 6}>
          {(!!order?.client?.documentId || !!order?.client?.email || !!order?.client?.phones) && (
            <Card elevation={0} className={classes.card}>
              <List disablePadding className={classes.list}>
                <Item primary="Cliente:">{order?.client?.name}</Item>
                {!!order?.client?.documentId && (
                  <Item primary="CPF/CNPJ:">{formatDocument(order?.client?.documentId)}</Item>
                )}
                <Item primary="E-mail:">{order?.client?.email}</Item>
                {!!order?.client?.phones && (
                  <Item primary="Telefone:">{formatPhone(order?.client?.phones[0])}</Item>
                )}
              </List>
            </Card>
          )}
          {(order?.orderItems?.length > 0) && (
            <>
              <Card elevation={0} className={classes.card}>
                <List disablePadding className={classes.list}>
                  <Typography color="primary" variant="h6" style={{ marginLeft: 15 }}>Produtos</Typography>
                  {order?.orderItems?.map(item => {
                    return <Item primary={`${item?.quantity} ${item?.name}`}>{`R$ ${numericFormatter(item?.amount?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}`}</Item>
                  })}
                </List>
              </Card>
              {!isMobile && (
                <Grid container justify='flex-end'>
                  <Button
                    color="tertiary"
                    variant="outlined"
                    onClick={consultNfce}
                  >
                    Visualizar Nota Fiscal
                  </Button>
                </Grid>
              )}
            </>
          )}
        </Grid>
        {(+order?.situationId == 2) && (
          <>
            <Grid item xs={isMobile ? 12 : 6}>
              <Card elevation={0} className={classes.card}>
                <List disablePadding className={classes.list}>
                  <Item primary="Valor Total:">{`R$ ${numericFormatter(order?.totalAmount?.toString(), { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}`}</Item>
                </List>
              </Card>
            </Grid>
            {isMobile && (
              <Grid item xs={12}>
                <Grid container justify='flex-end'>
                  <Button
                    color="tertiary"
                    variant="outlined"
                    onClick={consultNfce}
                  >
                    Visualizar Nota Fiscal
                  </Button>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Loader>
  );
}